import TransactionStatusBadge from "./TransactionStatusBadge";
import TransactionLinkRenderer from "./TransactionLinkRenderer";
import TransactionDateFormatRenderer from "./TransactionDateFormatRenderer";
import TransactionDriverCarRenderer from "./TransactionDriverCarRenderer";
import React from 'react';
import { LuMapPin, LuMilestone, LuBuilding2 } from 'react-icons/lu';
import { PersonRenderer, iconCell } from 'components/common/ag-grid';

export const columnDefs = [
  { 
    headerName: 'ID#',
    field: 'booking_number',
    minWidth: 100,
    width: 120,
    flex: 0,
    pinned: 'left',
    cellRenderer: TransactionLinkRenderer
  },
  { 
    headerName: 'From date',
    field: 'from_date',
    minWidth: 200,
    cellRenderer: TransactionDateFormatRenderer
  },
  { 
    headerName: 'To date',
    field: 'to_date',
    minWidth: 200,
    cellRenderer: TransactionDateFormatRenderer
  },
  { 
    headerName: 'Pickup location',
    field: 'pickup_location',
    minWidth: 250,
    cellRenderer: iconCell(LuMapPin)
  },
  {
    headerName: 'Drop location',
    field: 'drop_location',
    minWidth: 250,
    cellRenderer: iconCell(LuMapPin)
  },
  { 
    headerName: 'Purpose trip',
    field: 'description',
    minWidth: 250,
  },
  { 
    headerName: 'Status',
    field: 'status_name',
    minWidth: 200,
    cellRenderer: TransactionStatusBadge
  },
  { 
    headerName: 'Route',
    field: 'route',
    minWidth: 150,
    cellRenderer: iconCell(LuMilestone)
  },
  { 
    headerName: 'Driver & Car',
    field: 'driver_name',
    minWidth: 300,
    cellRenderer: TransactionDriverCarRenderer
  },
  { 
    headerName: 'Site',
    field: 'site_name',
    minWidth: 200,
    cellRenderer: iconCell(LuBuilding2)
  },
  {
    headerName: 'Approved by',
    field: 'approved_by',
    minWidth: 150,
    cellRenderer: PersonRenderer
  },
  { 
    headerName: 'Approved date',
    field: 'approved_date',
    minWidth: 200
  },
  { 
    headerName: 'Source from Travel booking',
    field: 'travel_booking',
    minWidth: 120,
    cellRenderer: (params) => (
      <div className="tw-text-center">
        {params.data?.travel_booking_id != null
          ? <span className="tw-text-green-600 tw-font-bold">✓</span>
          : <span className="tw-text-slate-300">—</span>}
      </div>
    )
  },
  { 
    headerName: 'Created by',
    field: 'created_by',
    minWidth: 100,
    cellRenderer: PersonRenderer
  },
  { 
    headerName: 'Created date',
    field: 'created_at',
    minWidth: 200
  }
];
